export default __webpack_public_path__ + "static/media/preloader.bf99a714.svg";